// https://alidocs.dingtalk.com/i/nodes/G1DKw2zgV2RNLDK9FAmNYYmPVB5r9YAn?corpId=

export const FRONT_PAGE_NEW_SHELVES_STRUCTURE_FOR_KDT = 'FRONT_PAGE_NEW_SHELVES_STRUCTURE_FOR_KDT' // 前端新铺货结构-有赞

export const GOODS_RULE_OPERATE_V2 = 'GOODS_RULE_OPERATE_V2' // 运营中心白名单
export const ERP_AFTERSALE_BIGSHOP_AUTO = 'ERP_AFTERSALE_BIGSHOP_AUTO' // 售后-退款单、售后详情、售后单导入 区分跳erp白名单
export const NEW_AFTER_SALES_ISSUE_REGISTRATION_WHITELIST = 'NEW_AFTER_SALES_ISSUE_REGISTRATION_WHITELIST' // 售后问题登记分类白名单
export const PUSH_TO_SUPPLIER_AMOUNT_BY_AFTERSALE_TYPE_WHITELIST = 'PUSH_TO_SUPPLIER_AMOUNT_BY_AFTERSALE_TYPE_WHITELIST' // 售后自动化-按照售后分类设置金额白名单
export const AFTER_SALE_JD_AUTO_RETURN_REFUND_WHITE_LIST = 'AFTER_SALE_JD_AUTO_RETURN_REFUND_WHITE_LIST' // 售后自动化-京东收货回传配置
export const DIS_DRP_SPLIT_REPUSH_RECALC_WHITELIST = 'DIS_DRP_SPLIT_REPUSH_RECALC_WHITELIST' // 订单扣负数白名单
export const DRP_FREE_HANDLING_FEE_WHITE_LIST = 'DRP_FREE_HANDLING_FEE_WHITE_LIST' // 分销支付0费用白名单
export const DRP_FREE_HANDLING_FEE_V2_WHITE_LIST = 'DRP_FREE_HANDLING_FEE_V2_WHITE_LIST' // 分销支付0费用白名单V2
export const AFTERSALE_TWICE_EXCHANGE_ORDER_MULTI_PUSH = 'AFTERSALE_TWICE_EXCHANGE_ORDER_MULTI_PUSH' // 二次换货白名单
export const MULTI_LEVEL_DISTRIBUTION_REISSUE_NORMALIZE_AUTO_SYNC =
    'MULTI_LEVEL_DISTRIBUTION_REISSUE_NORMALIZE_AUTO_SYNC' // 手工创单-售后问题类型白名单
export const MULTI_ADDRESS_UPGRADE_SWITCH_WHITELIST = 'MULTI_ADDRESS_UPGRADE_SWITCH_WHITELIST' // 售后地址升级白名单
export const SUP_GOODS_STRATEGY_FOR_RETURN_ADDRESS_WHITE_LIST = 'SUP_GOODS_STRATEGY_FOR_RETURN_ADDRESS_WHITE_LIST' // 商品多地址退货策略

/** 塔内登录态治理白名单 */
export const INNER_API_USER_LOGIN_STATE_V2_WHITE_LIST = 'INNER_API_USER_LOGIN_STATE_V2_WHITE_LIST'

/** 售后-手动创建售后单-是否允许手动选择运费承担方 */
export const AFTER_SALE_ORDER_BEAR_FREIGHT_SELECTION_WHITELIST = 'AFTER_SALE_ORDER_BEAR_FREIGHT_SELECTION_WHITELIST'

/** 我的供应商-供应商售后地址，支持大店可编辑 */
export const AFTER_SALE_ADDRESS_MIDDLEMAN = 'AFTER_SALE_ADDRESS_MIDDLEMAN'

/** 拼多多发货回传退货地址 **/
export const DRP_SEND_UPLOAD_AFS_ADDRESS_PDD = 'DRP_SEND_UPLOAD_AFS_ADDRESS_PDD'

/** 达人管理：达人自动导入自然出单达人任务后缀白名单 */
export const DAREN_IMPORT_NATURAL_DAREN_SUFFIX_WHITELIST = 'DAREN_IMPORT_NATURAL_DAREN_SUFFIX_WHITELIST'

/** 降咨询：分销商在订单中支持查看「分销运费」计算规则，降低分销商咨询和提升订单处理效率（白名单） */
export const ORDER_FREIGHT_CALC_RULE_SHOW = 'ORDER_FREIGHT_CALC_RULE_SHOW'

/** 自动确认退货地址白名单 */
export const DRP_SEND_EXCHANGE_ALLOW_FUND_NEGATIVE = 'DRP_SEND_EXCHANGE_ALLOW_FUND_NEGATIVE' // 多级分销售后卡点：支持将中间商的换货售后单分销资金扣成负数后提交给供应商
export const RULE_OPERATE_ERP_LABEL_WHITE_LIST = 'RULE_OPERATE_ERP_LABEL_WHITE_LIST'
export const SUP_DIS_COMBINATION_PACKAGE_SELLER_COMPENSATION_WHITELIST =
    'SUP_DIS_COMBINATION_PACKAGE_SELLER_COMPENSATION_WHITELIST' // 极速退款确认
export const AFTERSALE_NEGOTIATION_ENABLE_WHITELIST = 'AFTERSALE_NEGOTIATION_ENABLE_WHITELIST' // 售后-拒绝退款协商
export const SEARCH_STOCK_BLOCK = 'SEARCH_STOCK_BLOCK' // 只看有货按钮 黑名单
export const DOU_YIN_SPU_MANAGE = 'DOU_YIN_SPU_MANAGE' // 是否具有新建SPU权限白名单
export const EXPRESS_INTERCEPTION_OLD_VERSION_WHITELIST = 'EXPRESS_INTERCEPTION_OLD_VERSION_WHITELIST' // 快递拦截下线白名单

export const DRP_RULE_MERGE = 'DRP_RULE_MERGE' // 分销规则白名单
export const GOODS_WECHAT_NOTIFY_COID = 'GOODS_WECHAT_NOTIFY_COID' // 订阅公众号白名单
export const HOT_GOODS_PRIVILEGE = 'HOT_GOODS_PRIVILEGE' // 优质分销商白名单
export const MULTI_LEVEL_DIS_SETTLEMENT_WHITE_LIST = 'MULTI_LEVEL_DIS_SETTLEMENT_WHITE_LIST' // 大店开票白名单
export const SETTLEMENT_IGNORE_AFTER_SALE_AMOUNT_WHITELIST = 'SETTLEMENT_IGNORE_AFTER_SALE_AMOUNT_WHITELIST' // 分销结算忽略售后金额白名单
export const PENDING_ORDERS_BY_SUPPLIER_COUNT = 'PENDING_ORDERS_BY_SUPPLIER_COUNT' // 推单异常按照供应商白名单
export const BATCH_UPDATE_DIS_PRICE_WHITE_LIST = 'BATCH_UPDATE_DIS_PRICE_WHITE_LIST' // 小站修改1-5级供货价白名单
export const SHOW_CURRENT_ARREARS_COIDS = 'SHOW_CURRENT_ARREARS_COIDS' // 分销资金明细是否显示当前欠款白名单

export default [GOODS_RULE_OPERATE_V2, DOU_YIN_SPU_MANAGE]

/** 售后自动化-平台自动化-可退款节点设置--支持拼多多白名单 */
export const AFTER_SALE_PDD_AUTO_REFUNDONLY_WHITE_LIST = 'AFTER_SALE_PDD_AUTO_REFUNDONLY_WHITE_LIST'

export const GOODS_DRAFT_STATUS = 'GOODS_DRAFT_STATUS' // 商品草稿状态白名单

export const ACCESS_PRE = 'ACCESS_PRE' // 只有这些用户才允许在pre环境

/** 分销推单：分销商将订单推送给供应商，支持自动拆分组合装，提升供应商订单处理效率（白名单） */
export const DRP_ORDER_PUSH_AUTO_SPLIT_COMBINE = 'DRP_ORDER_PUSH_AUTO_SPLIT_COMBINE'

/** 支持供应商配置自动退款给分销商策略，实现售后退款自动化白名单 */
export const SUPPLIER_AUTO_REFUND = 'SUPPLIER_AUTO_REFUND'
/** 分销订单：快递匹配查询工具增加匹配供应商低价快递逻辑，避免商家使用查询工具和分销商实际推单快递匹配不一致产生咨询（白名单） */
export const ORDER_SIMULATION_CALC_NEW = 'ORDER_SIMULATION_CALC_NEW'
export const DISTRIBUTOR_AFTERSALE_ORDER_SUPPORTS_FILTER_RETURN_LOGISTICS_STATUS =
    'DISTRIBUTOR_AFTERSALE_ORDER_SUPPORTS_FILTER_RETURN_LOGISTICS_STATUS' // 退货物流状态白名单
export const AFTERSALE_EXPRESS_INTERCEPT_TPW_SUPPLY_DISTRIBUTION_WHITELIST =
    'AFTERSALE_EXPRESS_INTERCEPT_TPW_SUPPLY_DISTRIBUTION_WHITELIST' // 快递拦截支持三方白名单
/** 自动生成换货订单白名单 */
export const AFTERSALE_EXCHANGE_AUTO_CONFIRM_WHITELIST = 'AFTERSALE_EXCHANGE_AUTO_CONFIRM_WHITELIST'

export const INSIDER_COID_LIST = 'INSIDER_COID_LIST' // 同DRP_SUPP_AUTOSPLIT ｜HOT_GOODS_PRIVILEGE，两个白名单key任意一个为true，都可以
export const ORDER_GUIDE_WHITELIST_MASTER_SLAVE = 'ORDER_GUIDE_WHITELIST_MASTER_SLAVE' // 订单列表判断是否数据为空时的白名单，用来请求接口的参数
export const PURCHASE_AMOUNT_SHARDING_WHITELIST = 'PURCHASE_AMOUNT_SHARDING_WHITELIST' // 订单列表采购金额为分步加载，是否请求

/** 订单：分销侧订单管理支持根据原始分销线上订单号查询筛选（白名单） */
export const ORDER_ORIGINAL_SOID_WHITELIST = 'ORDER_ORIGINAL_SOID_WHITELIST'

export const ASYNC_AUDIT_ORDER_WHITE_LIST = 'ASYNC_AUDIT_ORDER_WHITE_LIST' // 订单推单审核优化-是否开启异步

export const UNDERPRICED_ORDER_WHITELIST = 'UNDERPRICED_ORDER_WHITELIST' // 当日破价订单
export const CHANNEL_CUSTOMER_CENTER_DIY_DATE = 'CHANNEL_CUSTOMER_CENTER_DIY_DATE' // 分销客户中心自定义时间
/**
 * 售后极速版支持查看IPC视频功能
 */
export const AFTER_SALE_IPC_OPEN_V2 = 'AFTER_SALE_IPC_OPEN_V2'
export const AFTER_SALE_IPC_OPEN_MERGE = 'AFTER_SALE_IPC_OPEN_MERGE'
export const AS_SHIP_UPLOAD_RETURN_ADDRESS_WHITE_LIST = 'AS_SHIP_UPLOAD_RETURN_ADDRESS_WHITE_LIST' // 退货地址上传
export const GOODS_POOL_WEIGHT_DETAILS_WHITE_LIST = 'GOODS_POOL_WEIGHT_DETAILS_WHITE_LIST' // 找商品权重

/** 优先在线退款的白名单 */
export const PAY_REFUND_ONLINE_SUFFIX_WHITELIST = `PAY_REFUND_ONLINE_SUFFIX_WHITELIST`

/** 起采金额白名单 */
export const MIN_PURCHASE_COIDS = 'MIN_PURCHASE_COIDS'

/** 商品运营分析按sku粒度补货 */
export const GOODS_RULE_OPERATE_SKU_REPLENISHMENT = 'GOODS_RULE_OPERATE_SKU_REPLENISHMENT'

/** 异步处理售后操作（退货退款、仅退款）白名单 */
export const AFTER_SALES_RETURN_ASYNC_WHITELIST = 'AFTER_SALES_RETURN_ASYNC_WHITELIST'

/** erp预售库存白名单 */
export const DOUYIN_TIME_SALE_STOCK = 'DOUYIN_TIME_SALE_STOCK'

/** 免费版禁止预充值-免费版系统公告白名单 **/
export const FREE_SUPPLIER_FORBID_RECHARGE_SYSTEM_NOTICE_WHITE_LIST =
    'FREE_SUPPLIER_FORBID_RECHARGE_SYSTEM_NOTICE_WHITE_LIST'

export const CONFIRM_RECEIPT_EXCLUDE_GIFT_WHITELIST = 'CONFIRM_RECEIPT_EXCLUDE_GIFT_WHITELIST'

/** 分销服务费白名单 */
export const PUSH_ORDER_COMMERCIALIZE_WHITELIST = 'PUSH_ORDER_COMMERCIALIZE_WHITELIST'

/** AI预测商品资料 */
export const FORECAST_PLATFORM_WHITE_LIST = 'FORECAST_PLATFORM_WHITE_LIST'

/** 抖音新版类目 允许修改类目白名单 */
export const DY_ALLOW_MODIFY_CATEGORY = 'DY_ALLOW_MODIFY_CATEGORY'

/** 抖音多退款地址 */
export const UPLOAD_SHOP_RETURN_ADDRESS_WHEN_STOCKING_WHITELIST = 'UPLOAD_SHOP_RETURN_ADDRESS_WHEN_STOCKING_WHITELIST'

/** 售后自动化-自动同意退货 顶部退货地址策略文案白名单 */
export const SELF_RUN_ORDER_RETURN_ADDR_POLICY_WHITELIST = 'SELF_RUN_ORDER_RETURN_ADDR_POLICY_WHITELIST'

export const FIND_DAREN_WHITELIST = 'FIND_DAREN_WHITELIST' // 达人管理白名单

export const PRINTER_INOUT_LIST_5000_WHITELIST = 'PRINTER_INOUT_LIST_5000_WHITELIST' // 打单-待发货 分页允许 5000/条

// 分销版关闭打单拣货界面提示:
export const PRINTER_CLOSE_PROMT_WHITE_LIST = 'PRINTER_CLOSE_PROMT_WHITE_LIST'
// 分销版关闭打单拣货界面:
export const PRINTER_CLOSE_WHITE_LIST = 'PRINTER_CLOSE_WHITE_LIST'

export const ORDER_DRP_ZPLAN_SETLC_REFREIGHT = 'ORDER_DRP_ZPLAN_SETLC_REFREIGHT'

export const AUTONOMY_SYNC_PLATFORM_CATE_WHITE = 'AUTONOMY_SYNC_PLATFORM_CATE_WHITE' // 支持商家自主获取平台缺失类目信息

// 订单换商品
export const ORDER_EXCHANGE_GOODS_WHITE_LIST = 'ORDER_EXCHANGE_GOODS_WHITE_LIST'

// 分销佣金规则白名单
export const COMMISSION_SUPPORT_GOODS_SKU = 'COMMISSION_SUPPORT_GOODS_SKU'

// 分销佣金规则白名单
export const COMMISSION_EXTEND_REFUND_TYPE = 'COMMISSION_EXTEND_REFUND_TYPE'
// 极速推单：开启极速推单的关系对，限制使用库存同步，并告知权益降级（白名单）
export const DRP_EXPRESS_AGENCY_DELIVING_LIMIT_SYNC_STOCK = 'DRP_EXPRESS_AGENCY_DELIVING_LIMIT_SYNC_STOCK'

// PARTNER_SPU_SHOP_LINK_WHITE_LIST白名单:
export const PARTNER_SPU_SHOP_LINK_WHITE_LIST = 'PARTNER_SPU_SHOP_LINK_WHITE_LIST'

/** 订单：同步供应商的异常给分销商功能支持中间商自定义设置需同步的异常类型（白名单） */
export const DRP_NOT_SYNC_ABNORMAL = 'DRP_NOT_SYNC_ABNORMAL'

// 淘系商品导入
export const TAO_GOODS_SHELVES_TAO_PLATFORM = 'TAO_GOODS_SHELVES_TAO_PLATFORM'

// 天猫直接使用供应商已经维护产品资料
export const TMALL_BACTH_SHELVES_USE_PRODUCT_WHITELIST = 'TMALL_BACTH_SHELVES_USE_PRODUCT_WHITELIST'

// 大店：支持「超时自动赔付」流程，减少纠纷，提升分销合作体验（白名单）
export const ORDER_TIMEOUT_COMPENSATION = 'ORDER_TIMEOUT_COMPENSATION'

// 店铺商品：（淘、抖）支持发货类型
export const SHOP_ITEM_UPDATE_DELIVERY_TIME = 'SHOP_ITEM_UPDATE_DELIVERY_TIME'

// 水滴助手支持美美团电子面单打印
export const PRINTER_MTSGYY_UPGRADE_WAYBILL_WHITELIST = 'PRINTER_MTSGYY_UPGRADE_WAYBILL_WHITELIST'

// 分销商品长时间无销量自动删除功能支持销量统计周期最长至180天
export const CLEAR_PARTNER_SALE_MARK_WHITE_LIST = 'CLEAR_PARTNER_SALE_MARK_WHITE_LIST'

// 商家查看寄样商品的「交付」情况二期
export const DAREN_DELIVER_COLLECTION_SAMPLE_SUFFIX_WHITELIST = 'DAREN_DELIVER_COLLECTION_SAMPLE_SUFFIX_WHITELIST'
// 售后垂直化第一期
export const AFTER_SALE_VERTICAL_PHASE_ONE_WHITELIST = 'AFTER_SALE_VERTICAL_PHASE_ONE_WHITELIST'
// 订单：批量拆分订单支持拆分异常状态的供销+订单，提升图书行业商家分批发货操作效率（白名单）
export const ORDER_SPLIT_IGNORE_QUESTION = 'ORDER_SPLIT_IGNORE_QUESTION'
// 用户验证码
export const CAPTCHA_VALIDATE = 'CAPTCHA_VALIDATE'

// 规格 ai 填充
export const AI_FILL_SPEC_VALUE_WHITE_LIST = 'AI_FILL_SPEC_VALUE_WHITE_LIST'

// TikTok
export const TIKTOK_PLATFORM_WHITE_LIST = 'TIKTOK_PLATFORM_WHITE_LIST'

// https://devops.aliyun.com/projex/req/JSTGYL-44220# 《寻合作-找达人：找达人新增平台【快手】，支持商家找快手达人并一键加入公司达人库，提升商家找达人效率》
export const DAREN_FIND_DAREN_KS_WHITE_LIST = 'DAREN_FIND_DAREN_KS_WHITE_LIST'
// 找达人-微信视频号白名单
export const DAREN_FIND_DAREN_SPH_WHITE_LIST = 'DAREN_FIND_DAREN_SPH_WHITE_LIST'
